import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,{staticClass:"radio-btn",style:(_vm.cssVars),attrs:{"id":_vm.id,"ripple":false,"active-class":"selected"}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }